import type { AxiosResponse } from '@ori/axios';

import { STATUS_OK } from '../constants';

/**
 * Safely handle and return data on Axios response based on its status.
 */
export const handleResponse = <Response extends AxiosResponse, ErrorReturn, SuccessReturn>(
  response: Response,
  {
    onError,
    onSuccess,
  }: {
    onError: (response: Omit<Response, 'data'>) => ErrorReturn;
    onSuccess: (response: Response) => SuccessReturn;
  },
) => (response.status === STATUS_OK ? onSuccess(response) : onError(response));
